export default "__VITE_ASSET__DyoSeHDY__"